import React from 'react';
import TreatmentForm, {TreatmentFormBaseProps} from "./treatment-form";
import useFormFields from "../../Common/hooks/use-form-fields";
import {TreatmentListJson} from "../../../api/generated/medical-rest";
import TreatmentService from "../../../services/treatment-service";

type SimpleNoteFormProps = TreatmentFormBaseProps & {
    prefill?: TreatmentListJson;
    isPending?: boolean;
};

const SimpleNoteForm: React.FunctionComponent<SimpleNoteFormProps> = (props) => {

    const {formFields, createChangeHandler} = useFormFields<TreatmentListJson>({
        ...TreatmentService.EMPTY_TREATMENT_LIST_JSON,
        ...props.prefill
    });

    return (
        <TreatmentForm onFormSave={props.onFormSave} onFormCancel={props.onFormCancel}
                       onTimestampChange={createChangeHandler("timestamp")}
                       onNoteChange={createChangeHandler("note")}
                       onPrivateChange={createChangeHandler('isPrivate')}
                       isPending={props.isPending}
                       treatment={formFields}>
        </TreatmentForm>
    );
};

export default SimpleNoteForm;
